import AbortController from "abort-controller";
import * as DateFns from 'date-fns';

import { routeToSpecificScope } from '../../helpers/helpersts';
import { generatorHandler } from '../../helpers/helpers';
import * as TYPES from '../types';
import {requestData, putData} from "../../config/services/datasets";
import {addLoadingFlag, changeMessageLoading, subLoadingFlag} from "./loading";
import {SERVER} from "../../config/server.config";
import {CONTROLLER_SET,  MESSAGES, GAME} from "../../config/constants";
import {updateMetaDataEvent, toDataEvents} from './dataEvents';

export const replaceMonitorData = monitorData => {
  return {
    type: TYPES.UPDATE_MONITOR_DATA,
    monitorData,
  };
};

const getFormatedMonitorsData = results => {
  const monitorData = [];
  results.forEach(data => {
    if (data.type !== GAME) {
      const lastDrillIndex = (data.drills.length) -1;
      monitorData.push({
        id: data._id,
        teamId: data.teamId,
        siteName: data.siteName,
        practiceName: data.name,
        currentPeriod: !Number.isNaN(data.currentDrillIndex) && data.status ==='live' && data.drills && data.drills[data.currentDrillIndex] ? data.drills[data.currentDrillIndex].drillType : '-',
        start: data.startTime,
        end: data.drills[lastDrillIndex]? data.drills[lastDrillIndex].endTs : '-' , 
        totalElapsed: data.startTime && data.endTime ? data.endTime - data.startTime : data.status === 'live' ? new Date() - data.startTime : '-',
        processingStatus: data.status === 'future' ? 'No Started' :
          data.status === 'live' ? 'In Progress' :
            data.status === 'post' ? 'Complete' :
              '-',
        reviewedBy: data.reviewdBy === 'unkown'? 0 : data.reviewdBy,
        allData: data,
      });
    }
  });

  return monitorData;
};
const monitorGenerator = generatorHandler(
  function* (start, end, time, isLoading, scope, dispatch, controller) {
    yield new Promise((resolve) => setTimeout(resolve, 1010));
    dispatch(setLoadedMonitorEvents(start, end, time, isLoading, scope, dispatch, controller));
  }
  , (...args) => {
    const scope = args[4];
    const isLoading = args[3];
    const dispatch = args[5];

    if (isLoading) {
      dispatch(subLoadingFlag(scope));
    }
  }
);

export const getMonitorData = time => {
  return async (dispatch, getState) => {
    const path = getState().router.location.pathname;
    const { monitorData } = getState();
    const scope = routeToSpecificScope(path);

    let isLoading = false;
    if (!!!monitorData[time]) {
      isLoading = true;
      dispatch(addLoadingFlag(scope));
    } else {
      dispatch(changeMessageLoading(scope, null));
    }

    const start = DateFns.startOfDay(time).getTime();
    const end = DateFns.endOfDay(time).getTime();
    const controller = new AbortController();

    monitorGenerator(start, end, time, isLoading, scope, dispatch, controller);
  };
};

export const setLoadedMonitorEvents = (start, end, time, isLoading, scope, dispatch, controller) => {
  return async dispatch => {
    CONTROLLER_SET.add(controller);
    const results = await requestData(
      SERVER.NEW_SCHEDULE_LIST(start, end, 'nfl,ncaa-fbs,ncaa-mlax'),
      { signal: controller.signal }
    );
    CONTROLLER_SET.delete(controller);
    if (results && results.length) {
      const practices = results.map((practice) => toDataEvents(practice));
      practices.forEach((practice) => {
        dispatch(updateMetaDataEvent(practice.meta.gameId, practice.meta));
      });
      const monitorData = getFormatedMonitorsData(results);

      dispatch(replaceMonitorData({ [time]: monitorData }));
    } else if (results) {
      // if results to show message when the request was not aborted
      dispatch(changeMessageLoading(scope, MESSAGES.NO_DATA_FOUND));
    }
  };
};
export const checkReviewMonitor = (data, year, month, day) => {
  return async (dispatch, getState) => {
    const path = getState().router.location.pathname;
    const scope = routeToSpecificScope(path);
    dispatch(addLoadingFlag(scope));
    const results = await requestData(SERVER.PRACTICE_SCHEDULE(data.allData.gameId));
    if(results && results[0]){
      // eslint-disable-next-line no-unused-vars
      const putRes = await putData(SERVER.PUT_MONITOR_REVIEW_BY(data.id, data.allData.homeTeamId, data.allData.league, data.allData.type), {
        ...results[0],
        'reviewedBy': getState().user.givenName,
        'dsUpdateTimeStampChange': false,
      });
      dispatch(subLoadingFlag(scope));
      dispatch(getMonitorData(new Date(year, month - 1, day).getTime()));
    } else {
      dispatch(subLoadingFlag(scope));
    }
  };
};

export const cleanMonitorData = () => {
  return dispatch => {
    dispatch({ type: TYPES.REPLACE_MONITOR_DATA });
  };
};
